__turbopack_context__.v({
  "plContentShell": "sectionLayout-module__ZG_ixa__plContentShell",
  "plContentShellCentered": "sectionLayout-module__ZG_ixa__plContentShellCentered",
  "plDividerHorizontal": "sectionLayout-module__ZG_ixa__plDividerHorizontal",
  "plDividerVertical": "sectionLayout-module__ZG_ixa__plDividerVertical",
  "plPillarBody": "sectionLayout-module__ZG_ixa__plPillarBody",
  "plPillarEmphasis": "sectionLayout-module__ZG_ixa__plPillarEmphasis",
  "plPillarTitle": "sectionLayout-module__ZG_ixa__plPillarTitle",
  "plSectionHeader": "sectionLayout-module__ZG_ixa__plSectionHeader",
  "plSectionHeading": "sectionLayout-module__ZG_ixa__plSectionHeading",
  "plSectionLabel": "sectionLayout-module__ZG_ixa__plSectionLabel",
  "plSectionRoot": "sectionLayout-module__ZG_ixa__plSectionRoot",
  "plTitleStack": "sectionLayout-module__ZG_ixa__plTitleStack",
});
